import type { AdminQuoteDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { QuoteNoteForm } from '@/features/quote';
import { formatDateTime } from '@/shared/lib';
import { ContentCard } from '@/shared/ui';

export interface QuoteNotesSectionProps {
  readonly quoteRequestId: string;
  readonly notes: AdminQuoteDetail['notes'];
}

/** 내부 메모(견적 설계 §9-6) — 작성자·시각과 함께 쌓이고 고객에게 보이지 않는다. */
export const QuoteNotesSection = ({
  quoteRequestId,
  notes,
}: QuoteNotesSectionProps): ReactElement => (
  <ContentCard title="내부 메모" description="고객에게 보이지 않습니다.">
    {notes.length === 0 ? (
      <p className="text-sm text-muted-foreground">메모가 없습니다.</p>
    ) : (
      <ul className="flex flex-col gap-3">
        {notes.map((note) => (
          <li key={note.id} className="rounded-xl bg-foreground/[0.03] p-3 text-sm">
            <p className="text-xs text-muted-foreground">
              {note.authorName} · {formatDateTime(note.createdAt)}
            </p>
            <p className="mt-1 whitespace-pre-wrap wrap-anywhere">{note.body}</p>
          </li>
        ))}
      </ul>
    )}
    <div className="mt-5">
      <QuoteNoteForm quoteRequestId={quoteRequestId} />
    </div>
  </ContentCard>
);
